import { render, staticRenderFns } from "./SynthesisInfo.vue?vue&type=template&id=48e12df6"
import script from "./SynthesisInfo.vue?vue&type=script&lang=js"
export * from "./SynthesisInfo.vue?vue&type=script&lang=js"
import style0 from "./SynthesisInfo.vue?vue&type=style&index=0&id=48e12df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports